export default {
  // Hero section
  'hero.title': 'Zana za Kipaimara za Kipima Muda Mtandaoni',
  'hero.subtitle': 'Chagua chombo cha muda kinachofaa mahitaji yako',

  // Tool cards
  'timer.title': 'Kipima Muda',
  'timer.description': 'Kipima muda cha kuhesabu nyuma kwa kazi, masomo na maisha',
  'timer.longDescription': 'Kipima muda cha kuhesabu nyuma kwa uzalishaji, upishi na usimamizi wa muda',
  'timer.button': 'Anza Kipima Muda',

  'stopwatch.title': 'Saa ya Kusimamisha',
  'stopwatch.description': 'Chombo cha kipima muda cha usahihi wa juu',
  'stopwatch.longDescription': 'Saa ya kusimamisha ya usahihi wa juu kwa michezo, mafunzo na kipimo sahihi cha muda',
  'stopwatch.button': 'Anza Saa ya Kusimamisha',

  'worldclock.title': 'Saa ya Dunia',
  'worldclock.description': 'Tazama maeneo ya saa ulimwenguni kote',
  'worldclock.longDescription': 'Onyesho la wakati halisi wa miji mikuu ya kimataifa na mahesabu mahiri ya eneo la saa',
  'worldclock.button': 'Tazama Saa ya Dunia',

  // Features section
  'features.title': 'Kwa nini Chagua timer.today?',
  'features.reliable.title': 'Inategemewa na Sahihi',
  'features.reliable.desc': 'Kipimo cha muda cha usahihi wa millisekunde na kutegemewa kulingana na kivinjari',
  'features.crossPlatform.title': 'Jukwaa-kila-mahali',
  'features.crossPlatform.desc': 'Inafanya kazi bila matatizo kwenye vifaa vya dawati, kompyuta ndogo na simu za mkononi',
  'features.smartNotifications.title': 'Arifa Mahiri',
  'features.smartNotifications.desc': 'Tahadhari za sauti na arifa za dawati wakati muda unapoisha',
  'features.easyToUse.title': 'Rahisi Kutumia',
  'features.easyToUse.desc': 'Kiolesura safi na vidhibiti vya ufahamu kwa watumiaji wote',

  // Keywords section
  'keywords.timer': 'timer countdown pomodoro focus work break',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
